import React, { useState } from 'react';
import { css } from '@emotion/core';
import { Desktop, Tablet } from '../../constants/responsive';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
  FormattedHTMLMessage,
  FormattedMessage,
  Link,
  useIntl,
} from 'gatsby-plugin-intl';
import { QuestionCircleOutlined } from '@ant-design/icons';
import ProductDetailsDisclaimer from '../../components/ProductDetailsDisclaimer';
import { useStaticQuery, graphql } from 'gatsby';
import ScrollContainer from 'react-indiana-drag-scroll';

// 手机端三个boxes需要拖动观看（不循环）
const MobileSlider = ({ children }) => {
  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        justify-content: center;
      `}
    >
      {/* 此为循环滑动观看 
      <Slider
        // dots
        infinite
        // autoplay
        autoplaySpeed={10000}
        slidesToShow={1}
        slidesToScroll={1}
        variableWidth
        css={css`
          // height:300px;
          width: 100%;
          .slick-slide {
            margin-right: 15px;
          }
          height: 100%;
          margin-top: 68.8px;
          display: block;

          .slick-track div {
            height: 200px;
          }
          ${Tablet} {
            display: none;
          }
          ${Desktop} {
            display: none;
          }
        `}
      >
        {children}
      </Slider> */}

      <ScrollContainer
        css={css`
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-top: 68.8px;
          ${Tablet} {
            display: none;
          }
          ${Desktop} {
            display: none;
          }
        `}
      >
        {children}
      </ScrollContainer>

      <div
        css={css`
          padding-top: 9px;
          margin-top: 20px;
          display: none;
          flex-direction: row;
          ${Tablet} {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin-top: 20px;
            // height: 304px;
            width: 560px;
          }
          ${Desktop} {
            display: flex;
            margin-top: 0px;
            flex-direction: column;
            justify-content: flex-start;
            width: 392px;
            // height: 472px;
            // max-height: 472px;
          }
        `}
      >
        {children}
      </div>
    </div>
  );
};

// showStandard实际指显示第一个（左边）button的信息
const ProductDetailsBoxes = ({
  showStandard = true,
  productData,
  showBoxThree = true,
  firstButtonData = {},
  secondButtonData = {},
  yearlyReturn,
  remarks,
  maxDrawDown,
  productId = 0,
  showRiskSlider = false,
}) => {
  const intl = useIntl();
  const jumpToApp = () => {
    // 打开aqumon App或者跳转至下载
    const openApp = (src, downloadUrl) => {
      window.location.href = src;
      if (downloadUrl) {
        setTimeout(() => {
          window.location.href = downloadUrl;
        }, 2000);
      }
    };
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const reg = /android/i;
    if (reg.test(userAgent)) {
      openApp(
        'aqumon://www.aqumon.com/openwith?key=value&key2=value2',
        'https://go.onelink.me/a338/5548b5'
      );
    } else {
      openApp(
        'https://www.aqumon.com/app/',
        'https://itunes.apple.com/cn/app/aqumon/id1313188337'
      );
    }
  };
  // showBoxThree为true：表示显示【前三个股票组合】
  if (showBoxThree) {
    const lanMap = { en: 'en', 'zh-hans': 'zh-cn', 'zh-hant': 'zh-hk' };
    const data = useStaticQuery(graphql`
      query {
        allStocksIdAndWeight {
          edges {
            node {
              data {
                stock {
                  iuid
                  weight
                  isBackup
                  backupOrder
                  instrumentFlag
                }
              }
              pid
            }
          }
        }
        allStocks {
          edges {
            node {
              iuid
              contents {
                language
                info_name
                recommend_reason
                exchange_link
              }
            }
          }
        }
      }
    `);

    /* 找到本product-id对应的所有股票，选择前三个作为“组合内前3支股票” */
    var productStock = data.allStocksIdAndWeight.edges
      .map((node) => node.node)
      .filter((stock) => stock.pid === productData.pid)[0];
    /* 根据股票的iuid找到股票对应的名字（接口数据返回了股票名字的三种语言） */
    var iuidAndStockName = {};
    data.allStocks.edges
      .map((node) => node.node)
      .filter((stock) => {
        // 滤出前三支股票
        return (
          stock.iuid === productStock.data.stock[0].iuid ||
          stock.iuid === productStock.data.stock[1].iuid ||
          stock.iuid === productStock.data.stock[2].iuid
        );
      })
      .map((stock) => {
        // 找到股票名字三语中正确对应的语言
        stock.contents.map((item) => {
          if (lanMap[item.language] === intl.locale) {
            iuidAndStockName[stock.iuid] = item;
          }
        });
      });
  }
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  var showTag = false;
  if (productId === 13 || productId === 12) {
    showTag = true;
  }
  return (
    <MobileSlider>
      {/* 组合内容 */}
      <div
        css={css`
          background: #f2f2f2;
          height: 100%;
          width: 280px !important;
          // height: 171px;
          margin: 0 20px 0 0;
          padding: 14px 22px 20px 15px;
          border-radius: 11px;
          flex: 0 0 auto;

          ${Tablet} {
            width: 100% !important;
            height: 123px;
            // height: ${showTag ? '139px' : '123px'};
            margin: 0px 0px 10px 0;
            padding: 14px 19px 21px 15px;
            border-radius: 11px;
          }
          ${Desktop} {
            width: 100% !important;
            height: 106px;
            // height: ${showTag ? '149px' : '106px'};

            border-radius: 20px;
            margin: 0 0 12px 0;
            padding: 10px 20px 13px 20px;
            margin-top: ${showRiskSlider ? '156px' : '0'};
          }
        `}
      >
        <table
          css={css`
            width: 100%;
            ${Tablet} {
              font-size: 16px;
              line-height: 1.7;
            }
            ${Desktop} {
              font-size: 20px;
              line-height: 1.2;
            }
          `}
        >
          <tbody>
            <tr
              css={css`
                font-weight: bold;
              `}
            >
              <td
                css={css`
                  ${Tablet} {
                    padding-bottom: 5px;
                  }
                  ${Desktop} {
                    padding-bottom: 7px;
                  }
                `}
              >
                {intl.formatMessage({
                  id: `${firstButtonData}.content.title`,
                })}
              </td>
            </tr>
            <tr>
              <td>
                {intl.formatMessage({
                  id: `${firstButtonData}.content.subtitle-1`,
                })}
              </td>
              <td align='right'>
                {parseInt(productData.min_investment_amount).toLocaleString()}
                &nbsp;
                {productData.currency}
              </td>
            </tr>
            <tr>
              <td>
                {intl.formatMessage({
                  id: `${firstButtonData}.content.subtitle-2`,
                })}
              </td>
              <td align='right'>
                {/* showBoxThree为true: 表示显示【前三个股票组合】，此时股票数量可通过Array.length获得  */}
                {/* showBoxThree为false: 此时股票数量本地写死  */}
                {showBoxThree ? (
                  productStock.data.stock.length
                ) : (
                  <FormattedMessage id={`${firstButtonData}.content.value-2`} />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* 表现明细 */}
      <div
        css={css`
          background: #f2f2f2;
          height: 100%;
          width: 280px !important;
          // height: 171px;
          padding: 14px 22px 20px 15px;
          border-radius: 11px;
          flex: 0 0 auto;
          margin: 0 20px 0 0;
          ${Tablet} {
            width: ${showBoxThree ? '49% !important' : '100% !important'};
            padding: 16px 8px 13px 15px;
            border-radius: 11px;
            height: 230px;
            margin: 0;
          }
          ${Desktop} {
            width: 100% !important;
            height: 165px;
            margin: 0 0 15px 0;
            // margin-bottom: 15px;
            padding: 13px 20px 17px 20px;
            border-radius: 20px;
          }
        `}
      >
        {/* 免责声明 */}
        <ProductDetailsDisclaimer
          show={showDisclaimer}
          onClose={() => {
            setShowDisclaimer(false);
          }}
          pid={productData.pid}
        />
        <table
          css={css`
            width: 100%;
            ${Tablet} {
              font-size: 16px;
              line-height: 1.5;
            }
            ${Desktop} {
              font-size: 20px;
              line-height: 1.2;
            }
          `}
        >
          <tbody>
            <tr
              css={css`
                font-weight: bold;
              `}
            >
              <td
                css={css`
                  padding-bottom: 7px;
                  white-space: nowrap;
                `}
              >
                {intl.formatMessage({
                  id: `${firstButtonData}.performance-details.title`,
                })}
              </td>
            </tr>
            <tr>
              <td>
                {intl.formatMessage({
                  id: `${firstButtonData}.performance-details.subtitle-1`,
                })}
              </td>
              <td align='right'>
                {/* {intl.formatMessage({
                  id: `${firstButtonData}.performance-details.value-1`,
                })} */}
                {/* {productData.description_card_1.value_1} */}
                {yearlyReturn}
              </td>
            </tr>
            <tr>
              <td>
                {intl.formatMessage({
                  id: `${firstButtonData}.performance-details.subtitle-2`,
                })}
              </td>
              <td align='right'>{remarks}</td>
            </tr>
            <tr>
              <td>
                {intl.formatMessage({
                  id: `${firstButtonData}.performance-details.subtitle-3`,
                })}
              </td>
              <td align='right'>{maxDrawDown}</td>
            </tr>
            <tr>
              <td
                css={css`
                  font-size: 12px;
                  padding-top: 7px;
                `}
              >
                <QuestionCircleOutlined />
                <a
                  style={{
                    textDecoration: 'underline',
                    paddingLeft: '5px',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setShowDisclaimer(true);
                  }}
                >
                  {intl.formatMessage({
                    id: `${firstButtonData}.performance-details.disclaimer`,
                  })}
                </a>
              </td>
            </tr>
            {/*  */}
          </tbody>
        </table>
      </div>
      {/* 组合内前三支股票 */}
      {showBoxThree && (
        <div
          css={css`
            background: #f2f2f2;
            width: 280px !important;
            height: 100%;
            // height: 171px;
            padding: 14px 22px 20px 15px;
            border-radius: 11px;
            flex: 0 0 auto;

            ${Tablet} {
              width: 49% !important;
              padding: 14px 22px 13px 15px;
              height: 230px;
            }
            ${Desktop} {
              width: 100% !important;
              height: auto;
              padding: 13px 20px 17px 20px;
              border-radius: 20px;
            }
          `}
        >
          <table
            css={css`
              width: 100%;

              ${Tablet} {
                font-size: 16px;
                line-height: 1.5;
                // white-space: nowrap;
              }
              ${Desktop} {
                font-size: 20px;
                line-height: 1.2;
              }
            `}
          >
            <tbody>
              <tr
                css={css`
                  font-weight: bold;
                `}
              >
                <td
                  css={css`
                    padding-bottom: 7px;
                  `}
                >
                  {intl.formatMessage({
                    id: `${firstButtonData}.top-3-stocks.title`,
                  })}
                </td>
              </tr>
              <tr>
                <td
                  css={css`
                    max-width: 195px;
                    white-space: normal;
                  `}
                >
                  {iuidAndStockName[productStock.data.stock[0].iuid].info_name}
                </td>
                <td align='right'>
                  {(productStock.data.stock[0]['weight'] * 100).toFixed(2) +
                    '%'}
                </td>
              </tr>
              <tr>
                <td
                  css={css`
                    max-width: 195px;
                    white-space: normal;
                  `}
                >
                  {iuidAndStockName[productStock.data.stock[1].iuid].info_name}
                </td>
                <td align='right'>
                  {(productStock.data.stock[1]['weight'] * 100).toFixed(2) +
                    '%'}
                </td>
              </tr>
              <tr>
                <td
                  css={css`
                    max-width: 195px;
                    white-space: normal;
                  `}
                >
                  {iuidAndStockName[productStock.data.stock[2].iuid].info_name}
                </td>
                <td align='right'>
                  {(productStock.data.stock[2]['weight'] * 100).toFixed(2) +
                    '%'}
                </td>
              </tr>
              <tr>
                <td
                  css={css`
                    font-size: 12px;
                    padding-top: 0px;
                  `}
                >
                  {/* 【于APP内】:中文的红色文字在前边，英语的红色文字在后边 */}
                  <span
                    css={css`
                      text-decoration: ${intl.locale === 'en'
                        ? 'none'
                        : 'underline'};
                      color: ${intl.locale === 'en' ? '#000000' : '#ee2f79'};
                      pointer-events: ${intl.locale === 'en' ? 'none' : 'auto'};
                      ${Tablet} {
                        pointer-events: none;
                      }
                      ${Desktop} {
                        pointer-events: none;
                      }
                    `}
                    onClick={jumpToApp}
                  >
                    {intl.formatMessage({
                      id: `${firstButtonData}.top-3-stocks.in-app`,
                    })}
                  </span>
                  <span
                    css={css`
                      text-decoration: ${intl.locale === 'en'
                        ? 'underline'
                        : 'none'};
                      color: ${intl.locale === 'en' ? '#ee2f79' : '#000000'};
                      pointer-events: ${intl.locale === 'en' ? 'auto' : 'none'};
                      ${Tablet} {
                        pointer-events: none;
                      }
                      ${Desktop} {
                        pointer-events: none;
                      }
                    `}
                    onClick={jumpToApp}
                  >
                    {intl.formatMessage({
                      id: `${firstButtonData}.top-3-stocks.view`,
                    })}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </MobileSlider>
  );
};

export default ProductDetailsBoxes;
